import React from 'react';
import classNames from 'classnames';
import { Field, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import InputField from 'components/InputField';
import validations from 'validations';
import { ResInputProps } from 'components/InputField/InputField.component';
import { getIn } from 'final-form';

import './DurationDaysField.styles.scss';

const MIN_DAYS = 1;
const MAX_DAYS = 180;

type DurationDaysFieldProps = {
  className?: string;
  name: string;
  maxDays?: number;
  minDays?: number;
  label?: string;
  required?: boolean;
  copyForMinValidation?: string;
  copyForMaxValidation?: string;
} & ResInputProps;

const DurationDaysField: React.FC<DurationDaysFieldProps> = (props) => {
  const {
    className,
    name,
    label,
    required,
    children,
    maxDays = MAX_DAYS,
    minDays = MIN_DAYS,
    copyForMinValidation = 'minDays',
    copyForMaxValidation = 'maxDays',
    ...rest
  } = props;

  const classes = classNames('duration-days-field', className);

  const { t } = useTranslation();

  const { values } = useFormState();

  const value = getIn(values, name);

  return (
    <div className={classes}>
      {label}
      <Field
        type="number"
        name={name}
        className="number-input"
        component={InputField}
        validate={validations.composeValidators(
          required ? validations.required() : null,
          validations.numbersOnlyValidation(t('numberInvalid')),
          validations.minNumber(
            t(copyForMinValidation, { count: minDays }),
            minDays,
          ),
          validations.maxNumber(
            t(copyForMaxValidation, { count: maxDays }),
            maxDays,
          ),
        )}
        {...rest}
      />
      {t('days', { count: +value })}
      {children}
    </div>
  );
};

export default DurationDaysField;
